var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthandwellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48837 15.0002C1.2214 15.0002 1 14.7788 1 14.5118C1 14.2449 1.2214 13.9314 1.48837 13.9314H14.5116C14.7786 13.9314 15 14.2449 15 14.5118C15 14.7788 14.7786 15.0002 14.5116 15.0002H1.48837Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94833 15C1.68136 15 1.45996 14.7786 1.45996 14.5116V4.09302C1.45996 2.12651 2.77665 1 4.74316 1H11.2548C13.2213 1 14.3841 2.00803 14.3841 3.97454V14.3931C14.3841 14.6601 14.1264 15 13.8594 15H1.94833ZM13.4604 14.0232V4.09294C13.4604 2.64736 12.6428 1.92367 11.1972 1.92367H4.6856C3.24001 1.92367 2.37648 2.64736 2.37648 4.09294V14.0232H13.4604Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04648 15.0001C5.7795 15.0001 5.55811 14.7787 5.55811 14.5117V10.5657C5.55811 9.96009 6.00929 9.31299 6.61488 9.31299H9.30418C9.90976 9.31299 10.4483 9.96009 10.4483 10.5657V14.5117C10.4418 14.7787 10.2204 15.0001 9.95345 15.0001H6.04648ZM9.46475 14.0233V10.3723C9.46475 10.3072 9.41266 10.2486 9.34103 10.2486H6.65172C6.58661 10.2486 6.52801 10.3007 6.52801 10.3723V14.0233H6.53452H9.46475Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51172 7.34868V4.09286C7.51172 3.82589 7.73311 3.60449 8.00009 3.60449C8.26707 3.60449 8.48846 3.82589 8.48846 4.09286V7.34868C8.48846 7.61565 8.26707 7.83705 8.00009 7.83705C7.73311 7.83705 7.51172 7.61565 7.51172 7.34868Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37167 6.20917C6.1047 6.20917 5.8833 5.98777 5.8833 5.72079C5.8833 5.45382 6.1047 5.23242 6.37167 5.23242H9.62749C9.89446 5.23242 10.1159 5.45382 10.1159 5.72079C10.1159 5.98777 9.89446 6.20917 9.62749 6.20917H6.37167Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthandwellness);
export default __webpack_public_path__ + "static/media/health and wellness.8b31f1a0a356705ca765b84b06ee06c9.svg";
export { ForwardRef as ReactComponent };